import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import {styled} from "@material-ui/core/styles";

const FullDiv = styled('div')({
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});

export const Spinner = () => {
    return (
        <FullDiv className="spinnerdiv">
            <FontAwesomeIcon icon={faSpinner} className="spinner" size='2x' spin/>
        </FullDiv>
    )
}

